import React from "react";

interface Props {
  className: string;
  isOpen: boolean;
}

const Table = ({ className, isOpen }: Props) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1072_18158)">
        {isOpen ? (
          <>
            <rect width="24" height="24" rx="12" fill="#FCFCFD" />
            <rect
              width="25.6"
              height="25.6"
              transform="translate(-0.800049 -0.800049)"
              fill="#667085"
              fillOpacity="0.12"
            />
          </>
        ) : null}
        <path
          d="M17.4167 17.9164H7.24998C6.92776 17.9164 6.64998 17.7997 6.41665 17.5664C6.18332 17.3331 6.06665 17.0609 6.06665 16.7497V7.24974C6.06665 6.92752 6.18332 6.64974 6.41665 6.41641C6.64998 6.18307 6.92776 6.06641 7.24998 6.06641H17.4167C17.7389 6.06641 18.0167 6.18307 18.25 6.41641C18.4833 6.64974 18.6 6.92752 18.6 7.24974V16.7497C18.6 17.0609 18.4833 17.3331 18.25 17.5664C18.0167 17.7997 17.7389 17.9164 17.4167 17.9164ZM7.03332 9.38307H17.6333V7.24974C17.6333 7.19418 17.6111 7.14418 17.5667 7.09974C17.5222 7.0553 17.4722 7.03307 17.4167 7.03307H7.24998C7.19443 7.03307 7.14443 7.0553 7.09998 7.09974C7.05554 7.14418 7.03332 7.19418 7.03332 7.24974V9.38307ZM9.48332 10.3497H7.03332V16.7497C7.03332 16.7942 7.05554 16.8386 7.09998 16.8831C7.14443 16.9275 7.19443 16.9497 7.24998 16.9497H9.48332V10.3497ZM15.1833 10.3497V16.9497H17.4167C17.4722 16.9497 17.5222 16.9275 17.5667 16.8831C17.6111 16.8386 17.6333 16.7942 17.6333 16.7497V10.3497H15.1833ZM14.2167 10.3497H10.45V16.9497H14.2167V10.3497Z"
          fill="#475467"
        />
      </g>
      <defs>
        <clipPath id="clip0_1072_18158">
          <rect width="24" height="24" rx="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Table;
